// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter_date_box {
    position: relative;
    width: 100%;
    min-width: 100px;
    max-width: 350px;
    background-color: white;
    height: 50px;
    border-radius: 4px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
}

.filtering_item {
    margin-bottom: 20px;
    margin-right: 10px;
}

.filter_date_space {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.filter_date_space > p {
    font-size: 12px;
    color: #0E0A40;
}
#arrow_svg {
    fill: #CCCCCC;
}
.filter_date_drop {
    position: absolute;
    top: 55px;
    right: 0;
    width: 320px;
    min-height: 200px;
    background-color: white;
    z-index: 2;
    border-radius: 3px;
    padding-bottom: 10px;
}

@media (max-width: 920px) {
    .filter_date_drop {
        top: 55px;
        left: 0;
    }
}

.filter_date_btn_box {
    margin-top: 10px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.filter_date_btn_box > button:last-child {
    margin-left: 10px;
}

.filter_date_clear_btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}

.filter_date_clear_btn > p {
    margin-bottom: 0;
    cursor: pointer;
    font-size: 14px;
    color: #0E0A40;
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/FilterDatePicker.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI;QACI,SAAS;QACT,OAAO;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":[".filter_date_box {\n    position: relative;\n    width: 100%;\n    min-width: 100px;\n    max-width: 350px;\n    background-color: white;\n    height: 50px;\n    border-radius: 4px;\n    padding-left: 10px;\n    padding-right: 10px;\n    cursor: pointer;\n}\n\n.filtering_item {\n    margin-bottom: 20px;\n    margin-right: 10px;\n}\n\n.filter_date_space {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.filter_date_space > p {\n    font-size: 12px;\n    color: #0E0A40;\n}\n#arrow_svg {\n    fill: #CCCCCC;\n}\n.filter_date_drop {\n    position: absolute;\n    top: 55px;\n    right: 0;\n    width: 320px;\n    min-height: 200px;\n    background-color: white;\n    z-index: 2;\n    border-radius: 3px;\n    padding-bottom: 10px;\n}\n\n@media (max-width: 920px) {\n    .filter_date_drop {\n        top: 55px;\n        left: 0;\n    }\n}\n\n.filter_date_btn_box {\n    margin-top: 10px;\n    width: 100%;\n    padding-left: 10px;\n    padding-right: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.filter_date_btn_box > button:last-child {\n    margin-left: 10px;\n}\n\n.filter_date_clear_btn {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 15px;\n}\n\n.filter_date_clear_btn > p {\n    margin-bottom: 0;\n    cursor: pointer;\n    font-size: 14px;\n    color: #0E0A40;\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
